/**
 * Cinematic Reveal — Sekcija 4: copy + hint (video scrub u sekciji 3).
 */
(function () {
  const SCRUB = 0.4;
  const HEADING_CENTERS = [0.2, 0.75];

  function parseConfig(section) {
    const el = section.querySelector("[data-reveal-config]");
    if (!el) return { scrollHeightVh: 280, videoEnd: 1.0 };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { scrollHeightVh: 280, videoEnd: 1.0 };
    }
  }

  function initReveal(section) {
    if (section.dataset.revealInit === "1") return;
    section.dataset.revealInit = "1";

    const config = parseConfig(section);
    const track = section.querySelector("[data-track]");
    const pin = section.querySelector("[data-pin]");
    const scrollPip = section.querySelector("[data-scroll-pip]");
    const headingStages = section.querySelectorAll(
      "[data-heading-stages] .cvr__heading-stage"
    );

    const unified = !!document.querySelector("[data-cine-unified]");

    if (unified) {
      section.classList.add("cvr--unified");
      if (track) {
        track.style.setProperty("--scroll-vh", "0");
        track.style.height = "0";
      }
    } else if (track) {
      track.style.setProperty("--scroll-vh", String(config.scrollHeightVh));
    }

    const updateHeadingMorph = (progress) => {
      if (!headingStages || !headingStages.length) return;
      const stages = Array.from(headingStages);
      const fadeIn = 0.1;
      const widths = 0.28;
      stages.forEach((el, i) => {
        const center =
          HEADING_CENTERS[i] !== undefined ? HEADING_CENTERS[i] : 0.5;
        const d = Math.abs(progress - center);
        let op;
        if (d <= widths - fadeIn) op = 1;
        else if (d >= widths) op = 0;
        else op = 1 - (d - (widths - fadeIn)) / fadeIn;
        const y = (progress - center) * 48;
        el.style.opacity = op.toFixed(3);
        el.style.transform = `translateY(${y.toFixed(1)}px)`;
      });
    };

    const applyProgress = (progress) => {
      const p = Math.max(0, Math.min(1, progress));
      if (scrollPip) {
        scrollPip.style.setProperty("--scroll-progress", p * 100 + "%");
      }
      updateHeadingMorph(p);
    };

    if (unified) {
      window.addEventListener("le-cine-reveal", (e) => {
        const { active, progress } = e.detail || {};
        if (active) {
          section.classList.add("cvr--live");
          section.classList.remove("cvr--past");
          applyProgress(typeof progress === "number" ? progress : 0);
        } else {
          section.classList.remove("cvr--live");
        }
      });
      return;
    }

    const initScroll = () => {
      if (
        typeof gsap === "undefined" ||
        typeof ScrollTrigger === "undefined"
      ) {
        window.addEventListener("load", initScroll, { once: true });
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.create({
        trigger: track,
        start: "top top",
        end: "bottom bottom",
        scrub: SCRUB,
        pin: pin,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onEnter: () => section.classList.add("cvr--live"),
        onEnterBack: () => section.classList.add("cvr--live"),
        onLeaveBack: () => section.classList.remove("cvr--live"),
        onUpdate: (self) => applyProgress(self.progress),
      });
    };
    initScroll();
  }

  const boot = () => {
    document.querySelectorAll("[data-cinematic-reveal]").forEach(initReveal);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
